import { render, staticRenderFns } from "./AssignedDqrTable.vue?vue&type=template&id=739f6fa0&scoped=true&"
import script from "./AssignedDqrTable.vue?vue&type=script&lang=js&"
export * from "./AssignedDqrTable.vue?vue&type=script&lang=js&"
import style0 from "./AssignedDqrTable.vue?vue&type=style&index=0&id=739f6fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f6fa0",
  null
  
)

export default component.exports